import React, { FC, useEffect, useState } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { ModalContentProps } from '../../Modal'
import { handleTemplateSheetAnalysisInfoModal } from '../../../features/modals/modalsSlice'
import useTheme from '../../../hooks/useAppColor'
import { AnalysisApi } from '../../../types/entities/analysis.types'
import { useNavigate } from 'react-router-dom'
import { CreateSheet, TrashIcon } from '../../../icons'
import { DelTemplate, getAllTemplates } from '../../../features/templates/templatesSlice'
import { Button } from 'antd'

export const TemplateSheetUserInfoModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const navigate = useNavigate()
    const user_id = useAppSelector(state => state.profile.profile_id)
    const {templates} = useAppSelector(state => state.templates)
    const agent_id = useAppSelector(state => state.profile.profile_id)
    const handleTemplateInfo = (data: any) => dispatch(handleTemplateSheetAnalysisInfoModal(data))
    
    useEffect(() => {
        if (templates.length === 0) {
            dispatch(getAllTemplates({ agent_id: user_id }))
        }
    }, [dispatch, user_id])

    const handleDelTemplate = (id: number) => {
        dispatch(DelTemplate({
            temp_id: id,
            agent_id: agent_id
        }))
        dispatch(getAllTemplates({agent_id: agent_id}))
    }
   

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <p className={`fw-5 fz-l fw-6 ${getTheme("c-dark", "c-lg")}`}>Мои шаблоны</p>
                <div className='f-025'></div>
            </div>
            <div className="f-1 p-rel">
                <div className="list p-rel w-100p f-column scrollableItemsList gap-20">
                    {
                        templates.map((item) => {
                            return <div className={`d-f jc-between al-center pd-10-0 border-bottom`}>
                                <h2 key={item.title} className={`title ${getTheme("", "c-white")}`} onClick={() => handleTemplateInfo({name: item.title, analysis: item.analysis, url: item.url})}>
                                {item.title}
                                <p className={`fw-5 fz-m fw-5  ${getTheme("c-dark", "c-lg")}`}>{item.analysis[0].name}...</p>
                                </h2>
                                 <div onClick={() => handleDelTemplate(item.id)} className="d-f gap-5 al-center">
                                    <TrashIcon />
                                </div>
                            </div>
                        })
                    }
                </div>      
            </div>            
        </BorderedPageLayout>
    )
}
